import { useParams } from 'react-router-dom';
import useAccount from '@ubeya/shared/hooks/account/useAccount';

const useAccountUrl = ({ to }) => {
  const { accountId } = useAccount();
  const { branchId } = useParams();

  const linkWithAccountId = to?.includes(':accountId') ? to?.replace(/:accountId/, accountId) : to;
  const linkWithBranchId = linkWithAccountId.includes(':branchId')
    ? linkWithAccountId.replace(/:branchId/, branchId)
    : linkWithAccountId;

  return linkWithBranchId;
};

export default useAccountUrl;
